import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getMaternityCenterOrders } from '@/service/orderTypeApis';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: {},
};

/**
 * 指挥中心「开房数」：GET /order-total/list 在住单总数（checkInStatus=2）的 totalRow。
 * 请求参数由 Page manual 里拼装；Redux 只落库。
 */
export const fetchCommandCenterOccupiedRooms = createAsyncThunk(
  'commandCenterOccupiedRooms/fetchCommandCenterOccupiedRooms',
  async ({ query = {} }, { rejectWithValue }) => {
    const storeId = query?.storeId;
    if (storeId === undefined || storeId === null || String(storeId).trim() === '') {
      return { data: { totalRow: 0 }, query };
    }
    try {
      const response = await getMaternityCenterOrders(query);
      const body = response?.data && typeof response.data === 'object' ? response.data : {};
      const nested = body.data && typeof body.data === 'object' ? body.data : null;
      const totalRow = Number(body.totalRow ?? nested?.totalRow ?? 0) || 0;
      const records = Array.isArray(body.records)
        ? body.records
        : (Array.isArray(nested?.records) ? nested.records : []);
      return { data: { totalRow, records }, query };
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取在住订单总数失败');
    }
  },
);

const commandCenterOccupiedRoomsSlice = createSlice({
  name: 'commandCenterOccupiedRooms',
  initialState: defaultState,
  reducers: {
    resetCommandCenterOccupiedRoomsState: () => defaultState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCommandCenterOccupiedRooms.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.query = action.meta.arg.query ?? {};
      })
      .addCase(fetchCommandCenterOccupiedRooms.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.data = action.payload.data ?? {};
        state.query = action.payload.query ?? {};
      })
      .addCase(fetchCommandCenterOccupiedRooms.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.data = {};
      });
  },
});

export const { resetCommandCenterOccupiedRoomsState } = commandCenterOccupiedRoomsSlice.actions;
export default commandCenterOccupiedRoomsSlice.reducer;
